<template>
  <div class="advantages">
    <div class="title">What are the advantages of our products?</div>
    <div class="content">
      <div class="left_pic"></div>
      <div class="item_list">
        <div class="item" :class="activeAdvantage == index ? 'item_ative' : ''" v-for="(item,index) in advantageList" :key="index" @click="activeAdvantage = index">
          <div class="item_img">
            <img :src="activeAdvantage == index ? item.img_a : item.img" alt="">
          </div>
          <div class="item_title">{{ item.title }}</div>
          <div class="item_text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
          activeAdvantage: 0,
          advantageList:[
            {
              title: 'Quick Registration',
              text: 'Only a phone number and verification code are required to complete registration.  ',
              img: require('@/assets/advantage1.png'),
              img_a: require('@/assets/advantage1_a.png')
            },
            {
              title: 'Simple Process',
              text: 'Just provide your ID and other personal information to apply. ',
              img: require('@/assets/advantage2.png'),
              img_a: require('@/assets/advantage2_a.png')
            },
            {
              title: 'Fast Approval',
              text: 'Get quick approval results after submitting your documents. ',
              img: require('@/assets/advantage3.png'),
              img_a: require('@/assets/advantage3_a.png')
            },
            {
              title: 'Safe and Reliable',
              text: 'Our company was certified by the SEC in 2020.  ',
              img: require('@/assets/advantage4.png'),
              img_a: require('@/assets/advantage4_a.png')
            }
          ]
        };
    },
    created() {
    },
    methods: {

    }
};
</script>
<style lang="scss" scoped>
.advantages {
  margin-top: 207px;
  width: 100%;
  padding: 0 178px;
  box-sizing: border-box;
  .title {
    font-family: 'Lexend_Medium';
    font-weight: 500;
    font-size: 61px;
    color: #000000;
    line-height: 81px;
    text-align: center;
  }
  .content {
    margin-top: 74px;
    display: flex;
    justify-content: space-between;
    .left_pic {
      background: url('./../assets/advantage_img.png') 0 0 no-repeat;
      background-size: 100% 100%;
      width: 667px;
      height: 589px;
    }
    .item_list {
      width: 667px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 327px;
        height: 276px;
        margin-bottom: 36px;
        // display: flex;
        // justify-content: center;
        // flex-direction: column;
        border-radius: 10px;
        padding: 40px 38px;
        box-sizing: border-box;
        box-shadow: 2px 2px 30px 0px rgba(31, 29, 13, 0.09);
        cursor: pointer;
        .item_img {
          width:62px;
          height: 62px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item_title {
          font-family: 'Lexend_Medium';
          font-weight: 500;
          font-size: 27px;
          color: #1F1D0D;
          line-height: 30px;
          margin-top: 10px;
        }
        .item_text {
          font-family: 'Lexend_Regular';
          font-weight: 400;
          font-size: 17px;
          color: #29281E;
          line-height: 24px;
          margin-top: 13px;
        }
      }
      .item:hover {
        box-shadow: 2px 2px 30px 0px rgba(31, 29, 13, 0.09);
        transform: scale(1.05);
        transition: all 0.3s ease;
      }
      .item_ative {
        color: #fff;
        background-color: #0053FF;
        .item_title {
          color: #fff;
        }
        .item_text {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Advantages.vue